import { isStringNullOrWhiteSpace } from 'owa-strings';
import { FILE_ATTACHMENT_TYPE, ITEM_ATTACHMENT_TYPE, ITEM_ID_ATTACHMENT_TYPE, REFERENCE_ATTACHMENT_TYPE, } from './attachmentConstants';
export default function getTypeOfAttachment(attachment) {
    switch (attachment.__type) {
        case FILE_ATTACHMENT_TYPE:
            return 0 /* File */;
        case REFERENCE_ATTACHMENT_TYPE:
            return 1 /* Reference */;
        case ITEM_ATTACHMENT_TYPE:
            return 2 /* Mail */;
        case ITEM_ID_ATTACHMENT_TYPE:
            // This will solve a problem where we have a file being attached
            // but the assumption that the ItemId is always a Mail is misleading
            // since it can be a CalendarItem or any other Item on the Mailbox
            var itemIdAttachment = attachment;
            if (!isStringNullOrWhiteSpace(itemIdAttachment.AttachmentIdToAttach)) {
                return 0 /* File */;
            }
            return 2 /* Mail */;
        default:
            throw new Error("Invalid type of attachment " + attachment.__type);
    }
}
//# sourceMappingURL=getTypeOfAttachment.js.map